/* eslint-disable complexity */
import React, { Component } from 'react';
import classnames from 'classnames';
import Style from './index.less';
// import { observable } from 'mobx';
// import { observer } from 'mobx-react';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import Button from '@tencent/dui/lib/components/Button';
import { LiveState } from '@tencent/live-components';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
// PPT直播（live）的用户引导框，没有什么功能就是用户教育。
import i18n from '@i18next/i18n';
import QRCode from '@tencent/docs-qrcode';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { getHandledTenantLogo } from '@src/slide/infrastructure/module/dependent/config/tob/utils';
import { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

interface LiveInviteDialogProps {
    handleCloseDialog: (action) => void;
    darkMode?: boolean;
    hidePlay?: boolean;
    showArrow: boolean;
    hideClose?: boolean;
    hideAllowFlip?: boolean;
    liveManager: ILiveManager;
}

interface LiveInviteDialogState {
    allowFlip: boolean;
    visible: boolean;
    toastText: string;
    type: 'info' | 'success' | 'error' | 'loading' | 'warning';
    qrcodeUrl: string;
}

// @observer
class LiveInviteDialog extends Component<LiveInviteDialogProps, LiveInviteDialogState> {
    private url: string;
    private snackTimer: NodeJS.Timeout|null;
    public constructor(props) {
        super(props);
        this.url = this.props.liveManager.shareUrl;
        this.state = {
            allowFlip: this.props.liveManager.allowFlip(),
            visible: false,
            toastText: '',
            type: 'success',
            qrcodeUrl: '',
        };
        this.snackTimer = null;
    }

    public componentDidMount() {
        this.buildQrcode();
    }

    public render() {
        const showNoteTips = false; // 远程演示显示备注的提示语的开关
        const { url } = this;
        // const xsrf = '906147608296426f';
        // const qrcode = `https://docs.qq.com/cgi-bin/online_docs/qrcode?xsrf=${xsrf}&url=${encodeURIComponent(url)}&t=${Date.now()}`;

        const checkStye = {
            fontSize: showNoteTips ? '14px' : '16px',
        };
        // let { snackbarVisible, modalVisible } = this.state;
        const { visible, type, toastText, qrcodeUrl } = this.state;

        return (

            <Snackbar.Container className={classnames([Style['dialog-wrapper'], Style.bubble, Style.top, (this.props.darkMode ? Style['bubble-dark'] : null)])}>
                <Snackbar
                    onClose={this.handleSnackbarClose}
                    type={type}
                    visible={visible}
                >{toastText}</Snackbar>
                {this.props.showArrow
                    && <div className={this.props.darkMode ? Style['top-tip-dark'] : Style['top-tip']} />
                }
                <button aria-label="Close" className={Style['modal-close']} onClick={this.onClickClose}>
                    <span className={Style['modal-close-x']}></span>
                </button>
                <div className={Style['modal-content']}>
                    <h1 className={(this.props.darkMode ? Style['dark-text'] : null)}>{i18n.t('邀请好友加入')}</h1>
                    <div className={Style['sm-qrcode']}>
                        <img src={qrcodeUrl} style={{ width: '100%', height: '100%' }} />
                    </div>
                    {this.props.darkMode
                        ? <div className={Style['link-wrapper-dark']}>
                            <div className={Style['input-wrapper-dark']}>
                                <input id="bar" className={Style['input-link-dark']} type="text" value={url} onChange={() => {}}
                                />
                            </div>
                            <button className={Style['copy-text-dark']} data-clipboard-target="#bar" onClick={this.copyLink}>{i18n.t('复制链接')}</button>
                        </div>
                        : <div className={Style['link-wrapper']}>
                            <div className={Style['input-wrapper']}>
                                <input id="bar"
                                    className={Style['input-link']} type="text" value={url} onChange={() => {}}
                                />
                            </div>
                            <Button className={Style['copy-text']} data-clipboard-target="#bar" onClick={this.copyLink}>{i18n.t('复制链接')}</Button>
                        </div>
                    }
                    <div>
                        {showNoteTips && <div className={Style['note-tip']}>{i18n.t('手机打开演示链接，可同步查看备注。')}</div>}
                        {this.props.hidePlay ? null
                            : <Button className={Style['blue-button']} type="primary" size="large" onClick={this.onClickPlay}>{i18n.t('开始远程演示')}</Button>
                        }
                        {this.props.hideClose ? null
                            : <Button className={Style['white-button']} type="default" size="large" onClick={this.onClickEndShow}>{i18n.t('关闭邀请')}</Button>
                        }
                        {this.props.hideAllowFlip ? null
                            : <div className={Style['div-check']}>
                                <Checkbox
                                    checked={this.state.allowFlip}
                                    onChange={this.onCheckChanged} style={checkStye}>{i18n.t('允许观看者翻看文档全文')}</Checkbox>
                            </div>
                        }
                    </div>
                </div>
            </Snackbar.Container>
        );
    }

    private buildQrcode = () => {
        QRCode.make(this.url, {
            iconURL: getHandledTenantLogo(TENANT_CONFIG.TENANT_LOGO.SVG_COLOR),
        }).then((src) => {
            this.setState({
                qrcodeUrl: src,
            });
        });
    };

    private copyLink = async () => {
        const title = window.pray().pptTitle;
        const data = i18n.t('【远程演示】{0}\n{1}', { 0: title, 1: this.url });

        const copyPasteManager = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.copyPasteManager;
        const copyPaste = await copyPasteManager?.promise();
        copyPaste?.triggerCopyEvent(data);

        eventBus.emit(EventKeys.TRIGGER_COPY_EVENT, (triggerCopyEvent) => {
            triggerCopyEvent(data);
            const msg = {
                message: i18n.t('复制链接成功'),
                type: 'success',
                duration: 3000,
                autoClose: true,
            };
            this.showSnackbar(msg);
        });
    };

    private handleSnackbarClose = () => {
        this.setState({ visible: false });
    };

    private showSnackbar = (param) => {
        this.setState({
            visible: true,
            toastText: param.message,
            type: param.type,
        });
        if (this.snackTimer !== null) {
            clearTimeout(this.snackTimer);
        }
        this.snackTimer = setTimeout(this.handleSnackbarClose, param.duration);
    };

    private onClickClose = () => {
        this.onClose('close');
    };

    private onClickPlay = () => {
        this.onClose('play');
    };

    private onClickEndShow = () =>  {
        this.onClose('end show');
    };

    private onClose = (action) => {
        // 通过onClose回调父类传参数
        this.props.handleCloseDialog?.(action);
    };

    private onCheckChanged = (value) => {
        this.setState({ allowFlip: value });
        this.props.liveManager.setAllowFlip(value);

        const act = value ? 'open' : 'shut';
        // 上报
        if (this.props.liveManager.liveInfo.state === LiveState.OnAir) {
            // 演示中设置
            tdw({
                opername: 'doc_ppt',
                module: 'remote_initiate',
                action: `mid_${act}`,
            });
        } else if (this.props.liveManager.liveInfo.state === LiveState.Pause) {
            // 演示前设置
            tdw({
                opername: 'doc_ppt',
                module: 'remote_initiate',
                action: act,
            });
        }
    };
}

export default LiveInviteDialog;
